import { useSyncExternalStore } from 'react'
import { getSpellPeek, subscribeToSpellPeek } from '../shape-spell-peek'

/** Whether the Spell Check panel is peeking into this text frame's overflow. */
export function useShapeSpellPeek(shapeId: string): boolean {
  return useSyncExternalStore(subscribeToSpellPeek, () => getSpellPeek() === shapeId)
}
